import styled from "styled-components";
import {
  colors,
  getTypographyFontStyle,
  device,
} from "../../styles/global.style";

const SectionHeading = styled.h3`
  ${getTypographyFontStyle({ variant: "h3", weight: 500 })};
  color: ${(props) => props.color || colors.primary};
  text-align: left;
  margin: ${(props) => (props.noMargin ? "0" : "20px 0 0px")};
  letter-spacing: 2px;

  &::after {
    content: "";
    display: inline-block;
    margin-left: 8px; /* space between text and triangle */
    width: 0;
    height: 0;
    vertical-align: middle;
    border-style: solid;
    border-width: 0 0 9px 9px;
    border-color: transparent transparent #fadf89 transparent;
  }

  @media ${device.md} {
    margin: ${(props) => (props.noMargin ? "0" : "40px 0 0px")};
  }
`;
export default SectionHeading;
